import { render } from "./DashboardTemplate.vue?vue&type=template&id=a5e8c97c"
import script from "./DashboardTemplate.vue?vue&type=script&lang=js"
export * from "./DashboardTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script